<template>
    <div class="rfq" v-if="isAmministrativo">
		<b-modal
			no-close-on-backdrop
			title="Detail"
			class="modal-success"
			v-model="rowDetail"
			ok-variant="success"
			:ok-only="isClient && !canSend || !isClient && !canCharge"
			:ok-title="okTitle"
			size="xl"
            @ok="closeDetail()"
		>
			<b-container fluid class="dlgtable">
                <b-table
                    hover
                    sort-icon-left
                    :items="dettRows"
                    :fields="dettFields"
                >
                    <template v-slot:cell(urgent)="row">
                        <b-form-group>
                            <input type="checkbox" v-model="row.item.urgent" :disabled="!canSend" />
                        </b-form-group>
                    </template>
                    <template v-slot:cell(approved)="row">
                        <b-form-group>
                            <input type="checkbox" v-model="row.item.approved" :disabled="!canSend" />
                        </b-form-group>
                    </template>
                    <template v-slot:cell(qta)="row">
                        <b-form-group>
                            <input type="number" v-model="row.item.qta" :disabled="!canSend" />
                        </b-form-group>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-form-group>
                            <b-button size="sm" @click="delRow(row.item, row.index, $event.target)" class="mr-1">Delete</b-button>
                        </b-form-group>
                    </template>
                </b-table>
			</b-container>
		</b-modal>
        <b-container fluid>
            <b-row>
                <b-col>
                    <AgGridVue 
                        :style="`width: calc(100% - 0px); height: calc(100vh - 235px)`" 
                        class="ag-theme-alpine" 
                        :columnDefs="columnDefs" 
                        :rowData="rfq"
                        :defaultColDef="defaultColDef" 
                        :suppressColumnVirtualisation="false" 
                        @first-data-rendered="onFirstDataRendered" 
                        @grid-ready="onGridReady"
                        @row-double-clicked="onRowDoubleClicked">
                    </AgGridVue>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);


export default {
    name: "RFQ",
    components: {
        AgGridVue,
    },
    data() {
        return {
            canSend: false,
            canCharge: false,
            rowId: 0,
            dettRows: [],
            dettFields: [
                { key: 'item_id', label: 'Code', sortable: true },
                { key: 'item_descr', label: 'Description', sortable: true },
                { key: 'qta', label: 'Qta', sortable: true },
                { key: 'urgent', label: 'Urgent', sortable: true },
                { key: 'approved', label: 'Approved', sortable: true },
                { key: 'actions', label: 'Actions' }
            ],
            rowDetail: false,
            rfq: [],
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [
                { hide: this.isClient, headerName: "Client Code", field: "client_code", filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { hide: this.isClient, headerName: "Client Name", field: "client", filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { hide: true, field: "id" },
                { headerName: "Name", cellClass: 'ag-left-aligned-cell', field: "name", filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Surname", cellClass: 'ag-left-aligned-cell', field: "surname", filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "E-Mail", cellClass: 'ag-left-aligned-cell', field: "email", filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Request Date", field: "fts", sort: { direction: 'desc', priority: 0 }, filter: 'agDateColumnFilter', valueFormatter: this.dateFormatter, filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Sent Date", field: "fsent", filter: 'agDateColumnFilter', valueFormatter: this.dateFormatter, filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "In Charge Date", field: "ftakencharge", filter: 'agDateColumnFilter', valueFormatter: this.dateFormatter, filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Urgent", field: "urgente", filter: 'agTextColumnFilter', filterParams: { buttons: ['reset', 'apply'] }, },
            ],
        };
    },
    async mounted() {
        await this.loadData()
    },
    computed: {
        isClient() {
            console.log("mm1 ?", this.$store.getters.master, this.$store.getters.marsilli)
            return !this.$store.getters.marsilli
        },
        isAmministrativo() {
            return this.$store.getters.amministrativo
        },
        okTitle() {
            if(this.isClient && this.canSend)
                return 'Save and send'
            if(!this.isClient && this.canCharge)
                return 'Take in Charge'
            return 'Close'
        }
    },
    methods: {
        async delRow(item, index, target) {
            console.log("delete", item, index, target)
            this.dettRows.splice(index, 1)
        },
        async loadData() {
            let rfq = await API.getRequests();
            this.rfq = rfq.map((t) => ({
                ...t,
                urgente: t.urgent ? "Yes" : "No",
                fts: new Date(t.ts),
                fsent: new Date(t.sent),
                ftakencharge: new Date(t.takencharge),
            }));
            console.log("rfq", this.rfq);
        },
        async onRowDoubleClicked(params) {
            console.log("rowDoubleClicked", params)
            this.rowDetail = true;
            this.dettRows = await API.getRequestDetail(params.data.id);
            this.canSend = !params.data.sent
            this.canCharge = !params.data.takencharge
            this.rowId = params.data.id
        },
        dateFormatter(params) {
            // console.log("???", params.value.getTime());
            return params.value.getTime() > 0 ? params.value.toLocaleDateString() : "-";
        },
        onGridReady(params) {
            console.log("Grid Ready")
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
            this.columnApi.applyColumnState({
                state: [{ colId: 'fts', sort: 'desc' }],
                defaultState: { sort: null },
            });
        },
        // eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
            this.columnApi.autoSizeAllColumns();
            console.log("autoSizeAllColumns1")
        },
        async closeDetail(){
            this.rowDetail=false
            console.log("closeDetail", this.canSend, this.isClient)
            if(this.canSend && this.isClient){
                console.log("save and send")
                await API.updateRequestDetail(this.rowId, this.dettRows)
                console.log("save and send 2")
                await API.sendRequest(this.rowId)
                await this.sendOrder()
            }
            if(this.canCharge && !this.isClient){
                console.log("take in charge")
                await API.takeInCharge(this.rowId)
                await this.loadData()
            }
        },
		async sendOrder(){
			console.log("invio...",this.dettRows)
			let cname = await API.getClientName()
			let ccode = this.$store.getters.client_code
			let login = this.$store.getters.login
			let name = this.$store.getters.name
			let email = this.$store.getters.email
			let surname = this.$store.getters.surname
			let subj = `Offer request from ${ccode} - ${cname} - ${login} - ${name} ${surname} - ${email}`
			let to = "quote_mail"
			let text = `Ricontattare il cliente per i dettagli\r\n`
			let html = `<b>Ricontattare il cliente per i dettagli</b><br><br>Machine: ${this.m ? this.m.codice : ''}<br><table>`
            let xlsx = []
			for(let oi of this.dettRows) {
                if(!oi.approved) continue
				text += `${oi.item_id} - ${oi.item_descr}\r\n`
				html += `<tr><td> ${oi.item_id} </td><td> ${oi.item_descr} </td><td> ${oi.qta} </td><td> ${oi.urgent ? 'Urgente' : ''}</td></tr>`
                // xlsx.push([{ type: 'String', value: oi.oi.item_id},{ type: 'Number', value: oi.reorder}])
                xlsx.push([{ value: oi.item_id},{ value: oi.reorder}])
			}
			html += "</table>"
            console.log("sendmail", to, subj, text, html, xlsx)
			await API.sendmail(to,subj,text,html,xlsx)
            this.mailSent = true
            await this.loadData()
		},
    }
};
</script>

<style scoped></style>
<style></style>
